import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';

import { Subscription } from 'rxjs';
import * as data from './helpers/menu.json';
import {MediaMatcher} from "@angular/cdk/layout";
import {Router} from "@angular/router";
import {InitService} from "./services/init.service";
import {CognitoService} from "./services/cognito.service";
import { ManagedLoginService } from './managed-login.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Explorandes - Operations';

  @ViewChild('drawer') snav:any;
  mobileQuery: MediaQueryList;
  isExpanded: boolean = true;
  matchesTemp: boolean = true;

  imgLogo = 'assets/brand/explo-horizontal-blanco.svg';
  menuData: any = (data as any).default;

  private estadoLayoutSubscription: Subscription | undefined;

  estadoInit: boolean = false;

  isTokenReady=false;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private serviceInit: InitService,
    private router: Router, private managedLoginService: ManagedLoginService
    ) {

    this.estadoLayoutSubscription = this.serviceInit.currentEstadoLayout.subscribe(
      e => {
        this.estadoInit = e;
        console.log('estado inittt',this.estadoInit);
        if(!this.estadoInit){
          this.matchesTemp = false;
        }
        else this.matchesTemp=true;
      }
    );
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change',this._mobileQueryListener);
    if (this.mobileQuery.matches ) {
      this.matchesTemp = false;
    }
  }

  private _mobileQueryListener: () => void;

  async ngOnInit() {
    console.log('menu',this.menuData);

    const idToken = localStorage.getItem('id_token');
    const refreshToken = localStorage.getItem('refresh_token');
  
    if (idToken && refreshToken) {
      if (this.managedLoginService.isTokenExpired()) {
        console.log("is expired")
        await this.managedLoginService.refreshToken()
      } else {
        console.log("is not expired, scheduling")
        this.managedLoginService.scheduleTokenRefresh();
      }
    }
    
    this.isTokenReady = true;
  }

  public signOut(): void {
    /* this.serviceInit.setEstadoLayout(false); */
    /* this.estadoLayoutSubscription = this.serviceInit.currentEstadoLayout.subscribe(
      e => {

        this.estadoInit = e;
        console.log('estado init',this.estadoInit);
        if(!this.estadoInit){
          this.matchesTemp = false;
          console.log('estado match',this.matchesTemp);
        }
      }
    ); */
/*     this.cognitoService.signOut()
      .then(() => {
        this.router.navigate(['/auth']);
      }); */

      try {
        this.managedLoginService.signOut();
      } catch (error) {
        console.log(error);
      }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
    this.estadoLayoutSubscription?.unsubscribe();
  }
}
